export default "__VITE_ASSET__0bJNDIH3__"